<!-- TEMPLATE -->
<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div class="card card-chart">
          <div class="card-header">
            <h3 class="card-title">
              <i class="tim-icons icon-sound-wave text-success"></i> # of
              Tickets
            </h3>
          </div>
          <div class="card-body">
            <line-chart
              :height="120"
              ref="usersChart"
              chart-id="users-line-chart"
              :chart-data="usersLineChart.chartData"
              :gradient-colors="usersLineChart.gradientColors"
              :gradient-stops="usersLineChart.gradientStops"
              :extra-options="usersLineChart.extraOptions"
            >
            </line-chart>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card-chart">
          <div class="card-header">
            <h3 class="card-title">
              <i class="tim-icons icon-minimal-down text-info"></i> Tickets
              Status
            </h3>
          </div>
          <div class="card-body">
            <bar-chart
              :height="120"
              ref="barChart"
              chart-id="blue-bar-chart"
              :chart-data="blueBarChart.chartData"
              :gradient-colors="blueBarChart.gradientColors"
              :gradient-stops="blueBarChart.gradientStops"
              :extra-options="blueBarChart.extraOptions"
            >
            </bar-chart>
          </div>
        </div>
      </div>
      <!--
        <div class="col-lg-4">
            
        <div class="card card-chart">
            <div class="card-header">
            <h3 class="card-title"><i class="tim-icons icon-key-25 text-success"></i>  Hijacked Credentials </h3>
            </div>
            <div class="card-body">
                 <line-chart 
                            :height="120"
                            ref="credsChart"
                            chart-id="creds-line-chart"
                            :chart-data="credsLineChart.chartData"
                            :gradient-colors="credsLineChart.gradientColors"
                            :gradient-stops="credsLineChart.gradientStops"
                            :extra-options="credsLineChart.extraOptions">
                </line-chart>
            </div>
        </div>
        </div>
        
        -->
    </div>

    <!--

		<div class="row">
			<div class="col-lg-12">
				<google-maps :data="hits"/>
			</div>	
		</div>
		<div class="row">
			<div class="col-lg-4">
				<div class="card">
					<div class="card-header">
						<h5 class="card-category">First seen </h5>
						
					</div>
					<div class="card-body">
						<h3 class="card-title" id="firstseen">
							<i class="tim-icons icon-calendar-60 text-success"></i> 
							{{ firstSeen | toReadableDate }}</h3>
					</div>
				</div>
				
			</div>
			<div class="col-lg-4">
				<div class="card ">
					<div class="card-header">
						<h3 class="card-category">Last seen</h3>
					</div>
					<div class="card-body">
						<h3 class="card-title" id="lastseen">
							<i class="tim-icons icon-calendar-60 text-warning"></i> 
							 {{ lastSeen | toReadableDate }}</h3>
					</div>
				</div>

			</div>
			<div class="col-lg-4">
				
				<div class="card ">
					<div class="card-header">
						<h5 class="card-category"> Visitors</h5>
					</div>
					<div class="card-body">
						<h3 class="card-title" id="hits">
							<i class="tim-icons icon-single-02 text-warning"></i>  {{ hitsCount }}
						</h3>
					</div>
				</div>
			</div>
             <div class="col-lg-12">
            
        <div class="card card-chart">
            <div class="card-header">
            <h3 class="card-title"><i class="tim-icons icon-world text-success"></i>  Domains detected </h3>
            </div>
            <div class="card-body">
                 <line-chart style="height: 150px"
                            ref="credsChart"
                            chart-id="creds-line-chart"
                            :chart-data="credsLineChart.chartData"
                            :gradient-colors="credsLineChart.gradientColors"
                            :gradient-stops="credsLineChart.gradientStops"
                            :extra-options="credsLineChart.extraOptions">
                </line-chart>
            </div>
        </div>
        </div>
		</div>
    </div>
    -->
  </div>
</template>

<!-- SCRIPT -->
<script>
//import UserInfoStore from '../app/user-info-store';
import PhishingApi from "../app/phishing-api";
import LineChart from "./chartjs/LineChart";
import BarChart from "./chartjs/BarChart";
import * as chartConfigs from "@/components/chartjs/config";
import config from "./chartjs/config-colors";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default {
  name: "DomainStatistics",
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    activeDomain: function () {
      return this.$store.state.activeDomain
        ? this.$store.state.activeDomain
        : null;
    },
    users: function () {
      return this.$store.state.statsForDomain
        ? this.$store.state.statsForDomain["users"]
        : null;
    },
    credentials: function () {
      return this.$store.state.statsForDomain
        ? this.$store.state.statsForDomain["credentials"]
        : null;
    },
    statusUp: function () {
      return this.$store.state.statsForDomain
        ? this.$store.state.statsForDomain["status_up"]
        : "";
    },
    statusDown: function () {
      return this.$store.state.statsForDomain
        ? this.$store.state.statsForDomain["status_down"]
        : "";
    },
    datasetUsers: function () {
      return this.parseAndGraphDataForUsersOrCredentials("users");
    },
    datasetCredentials: function () {
      return this.parseAndGraphDataForUsersOrCredentials("credentials");
    },
    datasetUpDown: function () {
      return this.parseAndGraphDatForUpDown();
    },
    blueBarChart: function () {
      let res = {
        extraOptions: chartConfigs.barChartOptions,
        chartData: this.parseAndGraphDatForUpDown(),
        gradientColors: config.colors.infoGradient,
        gradientStops: [1, 0.4, 0],
      };
      return res;
    },
    usersLineChart: function () {
      let res = {
        chartData: this.parseAndGraphDataForUsersOrCredentials("users"),
        extraOptions: chartConfigs.greenChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: [],
      };

      return res;
    },
    credsLineChart: function () {
      let res = {
        chartData: this.parseAndGraphDataForUsersOrCredentials("credentials"),
        extraOptions: chartConfigs.greenChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: [],
      };
      return res;
    },
  },
  mounted() {
    if (this.$store.state.activeDomain) {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      this.$store.dispatch("refreshGraphs");
    },

    populateGraphs() {
      this.parseAndGraphDataForUsersOrCredentials("credentials");
      this.parseAndGraphDataForUsersOrCredentials("users");
      this.parseAndGraphDatForUpDown();
    },
    convertTimestampToDate(v, i, arr) {
      return new Date(v.lastseen * 1000);
    },
    parseAndGraphDataForUsersOrCredentials(value) {
      let res = null;

      if (this.$store.state.statsForDomain) {
        let elements = this.$store.state.statsForDomain[value];
        let scaleFlag = 1; //just a flag for 1-Month, 0-Day scale

        //convert the timestamp to Date objects
        elements = elements.map(this.convertTimestampToDate);
        //sort the Dates in the array
        elements = elements.sort((a, b) => a - b);

        //get the unique months
        let uniqueLabels = elements.filter(
          (value, i, arr) =>
            arr.findIndex((t) => t.getMonth() === value.getMonth()) === i
        );

        if (uniqueLabels.length <= 2) {
          scaleFlag = 0;
          // less then two months, switch to days
          uniqueLabels = elements.filter(
            (value, i, arr) =>
              arr.findIndex((t) => t.getDate() === value.getDate()) === i
          );

          // get only Days in from Date object array
          uniqueLabels = uniqueLabels.map(function (v) {
            return v.getDate() + "/" + (v.getMonth() + 1);
          });
        } else {
          // continue with months; get only Months from Date objects in the array
          uniqueLabels = uniqueLabels.map(function (v) {
            return v.getMonth();
          });
        }
        //convert from index month to readable

        //loop thru user/credentials events now and count up the visits per month
        // basically two for loops
        let dataSet = [];
        let count = 0;
        uniqueLabels.forEach((i) => {
          elements.forEach((element) => {
            if (scaleFlag == 1) i === element.getMonth() ? count++ : null;
            if (scaleFlag == 0)
              i === element.getDate() + "/" + (element.getMonth() + 1)
                ? count++
                : null;
          });
          dataSet.push(count);
          count = 0;
        });

        //console.log(uniqueLabels)
        if (scaleFlag == 1) {
          uniqueLabels = uniqueLabels.map(function (v) {
            return monthNames[v];
          });
        }

        let chartData = {
          datasets: [
            {
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataSet,
            },
          ],
          labels: uniqueLabels,
        };
        return chartData;
        // if(value == 'users'){
        //     this.$refs.usersChart.updateGradients(chartData);
        //     this.usersLineChart.chartData = chartData;
        // }
        // else{
        //     this.$refs.credsChart.updateGradients(chartData);
        //     this.credsLineChart.chartData = chartData;
        // }
      }
    },
    getTicketsStatus(item) {
      // item = [{"ticket":"open", "timestamp":1231231}]
      try {
        return item.status[item.status.length - 1].ticket;
      } catch (e) {
        return null;
      }
    },

    parseAndGraphDatForUpDown() {
      let dataSet = [0, 0, 0, 0];
      if (this.$store.state.statsForDomain) {
        this.$store.state.statsForDomain["users"].forEach((element) => {
          let status = this.getTicketsStatus(element);
          switch (status) {
            case "open":
              dataSet[0]++;
              break;
            case "verified":
              dataSet[1]++;
              break;
            case "reported":
              dataSet[2]++;
              break;
            case "resolved":
              dataSet[3]++;
              break;
            default:
              console.log();
              break;
          }
        });
      }
      let chartData = {
        datasets: [
          {
            fill: true,
            borderColor: config.colors.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: config.colors.info,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataSet,
          },
        ],
        labels: ["Open", "Verified", "Reported", "Resolved"],
      };
      return chartData;
    },
  },
  components: {
    LineChart,
    BarChart,
  },
};
</script>

<!-- Style -->
<style>
</style>